import { api } from "./index";

export interface TenderRegistration {
  id: string;
  vendorId: string;
  tenderId: string;
  registeredAt: string;
  status: "REGISTERED" | "WITHDRAWN";
  tender?: {
    id: string;
    referenceNo: string;
    description: string;
    category: string;
    stage: string;
    publishingDate: string;
    submissionDeadline: string;
    openingDate?: string;
    requireRegistration: boolean;
  };
}

export interface TenderRegistrationStatus {
  registered: boolean;
  registration?: TenderRegistration;
}

export const tenderRegistrationsApi = {
  registerForTender: (tenderId: string): Promise<{ message: string; registration: TenderRegistration }> =>
    api.post(`/vendors/tenders/${tenderId}/register`, undefined, { useVendorAuth: true }).then((res) => res.data),

  withdrawFromTender: (tenderId: string): Promise<{ message: string }> =>
    api.post(`/vendors/tenders/${tenderId}/withdraw`, undefined, { useVendorAuth: true }).then((res) => res.data),

  listRegistrations: (): Promise<TenderRegistration[]> =>
    api.get("/vendors/registrations", { useVendorAuth: true }).then((res) => res.data),

  getRegistrationStatus: (tenderId: string): Promise<TenderRegistrationStatus> =>
    api.get(`/vendors/tenders/${tenderId}/registration-status`, { useVendorAuth: true }).then((res) => res.data),
};

